import React from 'react'
import styled from 'styled-components'
import Box from '@ntuctech/devex-tangram/Box'
import Link from '@ntuctech/devex-tangram/Link'
import Image from "next/legacy/image"
import Radio from '@ntuctech/devex-tangram/Radio'
import fpLogo from '../../../static/FPLogo/fp-logo.svg'
import { SCREEN_SIZE } from '../../../lib/Media'

export const OTPInputDiv = styled.div`
  height: 10rem;
  max-width: 86vw;
  margin-left: -0.5rem;
  padding-left: 0.5rem;

  ${SCREEN_SIZE.Below.MobileL} {
    ._ndsOtpInput--number {
      & > * {
        width: 3.1rem;

        input {
          height: 2.8rem;
          width: 2.8rem;
        }
      }
    }
  }

  ${SCREEN_SIZE.From.Tablet} {
    margin: 0;
  }
`

export const ContentText = styled.div`
  ${props => props.bold && 'font-weight: bold;'}
  ${props => props.footnote && 'color: #999999;'}
  ${props => props.extramargin && 'margin-top: 1rem;'}
`

export const ImageDiv = styled.div`
  position: relative;
  width: calc(50vw - 3rem);
  max-width: 10.5625rem;
  height: calc(22vh - 3rem);
  max-height: 7rem;
`

export const FPLogoSvg = styled(Image).attrs({
  src: fpLogo,
  width: 142.4,
  height: 32,
  loading: 'eager',
})``

const LogoWrapper = styled.div`
  ${props => props.extramargin && 'margin-bottom: 1rem;'}

  &[data-fplogo="true"] {
    text-align: center;
    ${SCREEN_SIZE.From.Tablet} {
      position: absolute;
      top: 1rem;
      left: 0;
      right: 0;
    }
  }

  &[data-nelogo='true'] {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const FPLogo = () => (
  <LogoWrapper data-testid="fp-logo" extramargin data-fplogo="true">
    <FPLogoSvg />
  </LogoWrapper>
)

export const Wrapper = styled.div`
  .styled-paper {
    margin-bottom: 1rem;

    ${SCREEN_SIZE.From.Tablet} {
      margin-top: 2.8rem;
    }
  }
`

export const StyledRadio = styled(Radio)`
  margin: 0.7rem 0;

  p {
    font-size: 1rem;
  }
`

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
  }

  label {
    cursor: pointer;
    word-break: break-all;

    &:first-letter {
      text-transform: capitalize;
    }
  }
`

export const PromptOTPWrapper = styled.div`
  button {
    margin-top: 2rem !important;
  }
`

const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`
export const TermsConditions = () => (
  <StyledBox m={2} data-testid="terms-policy">
    <Link
      href="https://help.fairprice.com.sg/hc/en-us/articles/360057578292--Terms-and-Conditions"
      target="_blank"
      size="m"
      rel="noopener noreferrer"
    >
      Terms and Conditions
    </Link>
    <Link
      href="https://help.fairprice.com.sg/hc/en-us/articles/4464676591129-Privacy-Notice-with-effect-from-2-April-2022-"
      target="_blank"
      size="m"
      rel="noopener noreferrer"
    >
      Privacy Notice
    </Link>
  </StyledBox>
)
